var map = {
	"./BoxList/BoxList": "55c5",
	"./BoxList/BoxList.vue": "55c5",
	"./Budget/Budget": "b460",
	"./Budget/Budget.vue": "b460",
	"./Mail": "a875",
	"./Mail.vue": "a875",
	"./MailType/Type1": "5ded",
	"./MailType/Type1.vue": "5ded",
	"./MailType/Type2": "e6d1",
	"./MailType/Type2.vue": "e6d1",
	"./MailType/Type3": "4691",
	"./MailType/Type3.vue": "4691",
	"./MailType/Type4": "c846",
	"./MailType/Type4.vue": "c846",
	"./Purchasing": "eb5e",
	"./Purchasing.vue": "eb5e",
	"./Purchasing/Type1": "fafa",
	"./Purchasing/Type1.vue": "fafa",
	"./Steps/Step2": "eb68",
	"./Steps/Step2.vue": "eb68",
	"./Steps/Step3": "581d",
	"./Steps/Step3.vue": "581d",
	"./Steps/Step4": "a496",
	"./Steps/Step4.vue": "a496",
	"./Steps/Steps": "a6a6",
	"./Steps/Steps.vue": "a6a6",
	"./img/box.png": "08e4",
	"./img/box@2x.png": "c4e4",
	"./img/car.png": "4bc8",
	"./img/car@2x.png": "4ce6",
	"./img/letter.png": "fd7e",
	"./img/pack.png": "eab1",
	"./img/组 295@2x.png": "3196",
	"./img/组 302@2x.png": "afef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10be";